import React from 'react';
import { Loader2, Upload } from 'lucide-react';
import { useBranchPublication } from '../hooks/useBranchPublication';

/** The primary button is the decision, not another confirmation entry point. */
export default function BranchReviewDecision({ onShowDetails, detailsOpen, ...props }) {
  const publication = useBranchPublication(props);
  return <div className="flex min-w-0 flex-wrap items-center gap-2" aria-label="Change approval controls">
    <button type="button" onClick={publication.publish} disabled={publication.disabled}
      title={publication.hint || undefined}
      className="inline-flex items-center gap-1.5 rounded-lg bg-cyan-900 px-3 py-2 text-xs font-semibold text-white transition hover:bg-cyan-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-700 focus-visible:ring-offset-2 disabled:opacity-40">
      {publication.busy ? <Loader2 size={14} aria-hidden="true" className="animate-spin" /> : <Upload size={14} aria-hidden="true" />}
      {publication.label}
    </button>
    {onShowDetails && <button type="button" onClick={onShowDetails} aria-expanded={Boolean(detailsOpen)}
      className="rounded-lg px-2 py-2 text-xs font-medium text-cyan-900 hover:bg-cyan-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-700">Approval details</button>}
    {(publication.error || publication.hint) && <p role={publication.error ? 'alert' : 'status'}
      className={'max-w-xs text-xs ' + (publication.error ? 'basis-full text-rose-800' : 'text-cyan-900')}>
      {publication.error || publication.hint}
    </p>}
  </div>;
}
